import PropTypes from 'prop-types';
import React from 'react';

import { Box, Grid, Typography, useMediaQuery } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { useTheme } from '@material-ui/core/styles';

import { CommonVehicleCard } from 'evee-ui-common/components/cards';
import { HorizontalScrollMenu } from 'evee-ui-common/components/base';

const Listings = ({ vehicles, loading }) => {
  const theme = useTheme();
  const isTabletOrMobile = useMediaQuery(theme.breakpoints.down('md'));
  const mobileVehiclesHeight = 398; // VehicleCard height in px
  const desktopVehiclesHeight = 418; // VehicleCard height in px + 20px margin bottom

  if (!loading && vehicles.length < 1) {
    return <></>;
  }

  const titleJsx = loading ? <Skeleton width="30%" /> : `Listings (${vehicles.length})`;

  const vehiclesListJsx = isTabletOrMobile ? (
    <HorizontalScrollMenu>
      <Box padding={`${theme.spacing(1)}px`}>
        <Grid container spacing={2} wrap="nowrap">
          {vehicles.map((item, index) => (
            <React.Fragment key={index}>
              <Grid item style={{ minWidth: '285px' }}>
                <CommonVehicleCard vehicle={item} />
              </Grid>
            </React.Fragment>
          ))}
        </Grid>
      </Box>
    </HorizontalScrollMenu>
  ) : (
    <Grid container spacing={2}>
      {vehicles.map((item, index) => (
        <React.Fragment key={index}>
          <Grid item xs={12} sm={4}>
            <CommonVehicleCard hideRating vehicle={item} />
          </Grid>
        </React.Fragment>
      ))}
    </Grid>
  );

  const listingsJsx = loading ? (
    <Skeleton
      variant="rect"
      height={isTabletOrMobile ? mobileVehiclesHeight : desktopVehiclesHeight}
      width="100%"
    />
  ) : (
    vehiclesListJsx
  );

  return (
    <>
      <Typography paragraph variant="h4">
        {titleJsx}
      </Typography>

      {listingsJsx}
    </>
  );
};

Listings.propTypes = {
  vehicles: PropTypes.array,
  loading: PropTypes.bool,
};

Listings.defaultProps = {
  vehicles: [],
  loading: false,
};

export default Listings;
